import { useEffect, useState } from "react";
import { useTheme } from "@emotion/react";
import { useDispatch, useSelector } from "react-redux";
import { Box, IconButton } from "@mui/material";
import { Icon } from "@iconify/react";
import CountLikeAndDislike from "./CountLikeAndDislike";
import { reactPostEntity } from "../../actions/index";
import { likeEntityPost, dislikeEntityPost } from "../../redux/slices/userSlice";

export default function ReactionsOptions({
    postId,
    entityName,
    url,
    countLikes,
    countDislikes,
    options = {},
}) {
    const reactions = useSelector((state) => state.postReact?.[entityName]) || {};
    const dispatch = useDispatch();
    const theme = useTheme();

    const [isLike, setIsLike] = useState(false);
    const [isDisLike, setIsDisLike] = useState(false);
    const [likesToShow, setLikesToShow] = useState(parseInt(countLikes));
    const [dislikesToShow, setDislikesToShow] = useState(parseInt(countDislikes));
    const [isDisabled, setIsDisabled] = useState(false);

    const { gapIcons = "4px", iconUnselectedColor = "white", iconSize = "small" } = options;

    useEffect(() => {
        setIsLike(reactions[postId] == "L");
        setIsDisLike(reactions[postId] == "D");
    }, [postId, reactions, likesToShow, dislikesToShow]);

    const handleLike = async () => {
        setIsLike(!isLike);
        setIsDisLike(false);
        setIsDisabled(true);
        reactPostEntity({
            url,
            id: postId,
            like: true,
            discount: reactions[postId] == "L",
        })
            .then(() => {
                if (reactions[postId] == "L")
                    setLikesToShow(parseInt(likesToShow) <= 0 ? 0 : parseInt(likesToShow) - 1);
                if (!reactions[postId]) setLikesToShow(parseInt(likesToShow) + 1);
                if (reactions[postId] == "D") {
                    setLikesToShow(parseInt(likesToShow) + 1);
                    setDislikesToShow(parseInt(dislikesToShow) <= 0 ? 0 : parseInt(dislikesToShow) - 1);
                    reactPostEntity({
                        url,
                        id: postId,
                        like: false,
                        discount: true,
                    }).catch((err) => console.log(err));
                }
            })
            .catch((err) => console.log(err))
            .finally(() => setIsDisabled(false));
        dispatch(likeEntityPost({ id: postId, entityName }));
    };

    const handleDisLike = async () => {
        setIsLike(false);
        setIsDisLike(!isDisLike);
        setIsDisabled(true);
        reactPostEntity({
            url,
            id: postId,
            like: false,
            discount: reactions[postId] == "D",
        })
            .then(() => {
                if (reactions[postId] == "D")
                    setDislikesToShow(parseInt(dislikesToShow) <= 0 ? 0 : parseInt(dislikesToShow) - 1);
                if (!reactions[postId]) setDislikesToShow(parseInt(dislikesToShow) + 1);
                if (reactions[postId] == "L") {
                    setDislikesToShow(parseInt(dislikesToShow) + 1);
                    setLikesToShow(parseInt(likesToShow) <= 0 ? 0 : parseInt(likesToShow) - 1);
                    reactPostEntity({
                        url,
                        id: postId,
                        like: true,
                        discount: true,
                    }).catch((err) => console.log(err));
                }
            })
            .catch((err) => console.log(err))
            .finally(() => setIsDisabled(false));
        dispatch(dislikeEntityPost({ id: postId, entityName }));
    };
    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                gap: gapIcons,
                zIndex: "50",
                paddingRight: "8px",
            }}
        >
            <IconButton
                onClick={handleLike}
                size={iconSize}
                color={theme.palette.primary.main}
                disabled={isDisabled}
            >
                {isLike ? (
                    <Icon icon="solar:like-bold" color={theme.palette.primary.main} />
                ) : (
                    <Icon icon="solar:like-broken" color={iconUnselectedColor} />
                )}
                <CountLikeAndDislike
                    sx={
                        isLike
                            ? {
                                  fontSize: "15px",
                                  marginLeft: "2px",
                                  color: theme.palette.primary.main,
                              }
                            : {
                                  fontSize: "15px",
                                  marginLeft: "2px",
                                  color: iconUnselectedColor,
                              }
                    }
                    count={likesToShow}
                />
            </IconButton>
            <IconButton onClick={handleDisLike} size={iconSize} disabled={isDisabled}>
                {isDisLike ? (
                    <Icon icon="solar:dislike-bold" color={theme.palette.primary.main} />
                ) : (
                    <Icon icon="solar:dislike-broken" color={iconUnselectedColor} />
                )}

                <CountLikeAndDislike
                    sx={
                        isDisLike
                            ? {
                                  fontSize: "15px",
                                  marginLeft: "2px",
                                  color: theme.palette.primary.main,
                              }
                            : {
                                  fontSize: "15px",
                                  marginLeft: "2px",
                                  color: iconUnselectedColor,
                              }
                    }
                    count={dislikesToShow}
                />
            </IconButton>
        </Box>
    );
}
